import React, { useState } from 'react';
import { Breadcrumbs } from 'Core/components';
import { ImageWithBasePath } from 'Core/components';
import { Link } from 'react-router-dom';
import { Filter, Sliders, Box } from 'react-feather';
import Select from 'react-select';
import { purchasereportdata } from '../../core/json/purchasereportdata';
import { Table } from 'Core/components';

const PurchaseReport = () => {
  const data = purchasereportdata;
  const [searchText, setSearchText] = useState('');
  const handleSearch = e => {
    setSearchText(e.target.value);
  };
  const filteredData = data.filter(entry => {
    return Object.keys(entry).some(key => {
      return String(entry[key]).toLowerCase().includes(searchText.toLowerCase());
    });
  });
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const toggleFilterVisibility = () => {
    setIsFilterVisible(prevVisibility => !prevVisibility);
  };

  const options = [
    { value: 'sortByDate', label: 'Sort by Date' },
    { value: '140923', label: '14 09 23' },
    { value: '110923', label: '11 09 23' },
  ];

  const productOptions = [
    { value: 'chooseProduct', label: 'Choose Product' },
    { value: 'boldV3.2', label: 'Bold V3.2' },
    { value: 'nikeJordan', label: 'Nike Jordan' },
  ];
  const columns = [
    {
      title: 'Product Name',
      dataIndex: 'productName',
      render: (text, record) => (
        <span className="productimgname">
          <Link to="#" className="product-img stock-img">
            <ImageWithBasePath alt="" src={record.img} />
          </Link>
          <Link to="#">{text}</Link>
        </span>
      ),
      sorter: (a, b) => a.productName.length - b.productName.length,
    },
    {
      title: 'Product Amount',
      dataIndex: 'productAmount',
      sorter: (a, b) => a.productAmount.length - b.productAmount.length,
    },

    {
      title: 'Product Qty',
      dataIndex: 'productQty',
      sorter: (a, b) => a.productQty.length - b.productQty.length,
    },

    {
      title: 'Instock Qty',
      dataIndex: 'instockQty',
      sorter: (a, b) => a.instockQty.length - b.instockQty.length,
    },
  ];
  return (
    <div className="page-wrapper">
      <div className="content">
        <Breadcrumbs maintitle="Purchase Report" subtitle=" Manage Your Purchase Report" />
        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="search"
                    className="form-control form-control-sm"
                    placeholder="Search"
                    aria-controls="DataTables_Table_0"
                    value={searchText}
                    onChange={handleSearch}
                  />
                  <Link to className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </Link>
                </div>
              </div>
              <div className="search-path">
                <Link
                  className={`btn btn-filter ${isFilterVisible ? 'setclose' : ''}`}
                  id="filter_search"
                >
                  <Filter className="filter-icon" onClick={toggleFilterVisibility} />
                  <span onClick={toggleFilterVisibility}>
                    <ImageWithBasePath src="assets/img/icons/closes.svg" alt="img" />
                  </span>
                </Link>
              </div>
              <div className="form-sort stylewidth">
                <Sliders className="info-img" />

                <Select
                  classNamePrefix="react-select"
                  className="img-select"
                  options={options}
                  placeholder="Sort by Date"
                />
              </div>
            </div>
            {/* /Filter */}
            <div
              className={`card${isFilterVisible ? ' visible' : ''}`}
              id="filter_inputs"
              style={{ display: isFilterVisible ? 'block' : 'none' }}
            >
              <div className="card-body pb-0">
                <div className="row">
                  <div className="col-lg-3">
                    <div className="input-blocks">
                      <Box className="info-img" />
                      <Select
                        className="img-select"
                        classNamePrefix="react-select"
                        options={productOptions}
                      />
                    </div>
                  </div>
                  <div className="col-lg-9 col-sm-6 col-12">
                    <div className="input-blocks">
                      <Link className="btn btn-filters ms-auto">
                        {' '}
                        <i data-feather="search" className="feather-search" /> Search{' '}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Filter */}
            <div className="table-responsive">
              <Table columns={columns} dataSource={filteredData} />
            </div>
          </div>
        </div>
        {/* /product list */}
      </div>
    </div>
  );
};

export default PurchaseReport;
